/*
    Made by : Samuel
    Date : 21
    Updated: April 23, 2025
 */

// ----------------------------------------------------------------------------- //
// IMPORTS //

import { useContext } from "react";
import { ThemeContext } from "../../../App";
import styles from "./Footer.module.css";

// ----------------------------------------------------------------------------- //
// PROPS //

// ----------------------------------------------------------------------------- //
// COMPONENT //

function Footer() {
    const { isDarkMode } = useContext(ThemeContext);

    return (
        <footer className={`${styles.footer} ${isDarkMode ? styles.darkFooter : styles.whiteFooter} py-4`}>
            <div className="container text-center">
                <p className={styles.footerText}>&copy; 2025 Bot Pombal. Todos os direitos reservados.</p>
                <p className={styles.footerText}>
                    Entre em contato:{" "}
                    <a href="mailto:robotica@aepombal.edu.pt" className={styles.emailLink}>
                        robotica@aepombal.edu.pt
                    </a>
                </p>
            </div>
        </footer>
    );
}

// ----------------------------------------------------------------------------- //
// EXPORTS //

export default Footer;

// ----------------------------------------------------------------------------- //
